import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { var_api } from "../../../constant";

const EstimationMaster = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [estimationData, setEstimationData] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [variantInputs, setVariantInputs] = useState([]);
  const [formDataDetails, setFormDataDetails] = useState({
    product_id: "",
    variant_id: "",
  });

  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
const [loading, setLoading] = useState(false);
  const business_id = localStorage.getItem("business_id") || 2 ;
  const warehouse_id = localStorage.getItem("warehouse_id") || 1;
 const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");const [pageLoading, setPageLoading] = useState(true);
  // const generateEstimationNumber = () => "EST-" + Date.now();
const [showStatusModal, setShowStatusModal] = useState(false);
const [selectedStatus, setSelectedStatus] = useState(null);
const [selectedEstimationId, setSelectedEstimationId] = useState(null);
const [statusUpdating, setStatusUpdating] = useState(false);

  // ✅ Fetch Estimation Data
  const fetchEstimationData = async () => {
     setPageLoading(true);
    try {
      const res = await axios.get(
        `${var_api}sa_veemart_estimation/get`
      );
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setEstimationData(data);
    } catch {
      toast.error("Failed to fetch estimations");
    }finally {
      setPageLoading(false); // stop loader
    }
  };

  // ✅ Fetch Product + Variant Data
  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setProductData(data);
    } catch {
      toast.error("Failed to fetch products");
    }
  };

  const fetchVariantData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setVariantData(data);
    } catch {
      toast.error("Failed to fetch variants");
    }
  };

  
  // ===== Add or Edit Modal Open =====
  const handleAddClick = () => {
    setIsEditing(false);
    setEditId(null);
    setVariantInputs([]);
    setShowDetailsModal(true);
    fetchProductData();
    fetchVariantData();
  };

  const handleEditClick = (id) => {
    fetchProductData();
    fetchVariantData();
  };

  // ===== Add Variant =====
  const handleAddVariant = () => {
    if (!formDataDetails.product_id || !formDataDetails.variant_id) {
      toast.error("Please select both Product and Variant");
      return;
    }

    const selectedProduct = productData.find(
      (p) => p.id === formDataDetails.product_id
    );
    const selectedVariant = variantData.find(
      (v) => v.id === formDataDetails.variant_id
    );

    const exists = variantInputs.some(
      (v) => v.variant_id === formDataDetails.variant_id
    );
    if (exists) {
      toast.warning("Variant already added!");
      return;
    }

    const newRow = {
      product_id: selectedProduct.id,
      product_name: selectedProduct.product_name,
      variant_id: selectedVariant.id,
      variant_name: selectedVariant.variant_name,
      uom: selectedVariant.uom || "-",
      gross_weight: selectedVariant.gross_weight || "-",
      net_weight: selectedVariant.net_weight || "-",
      qty: "",
      remarks: "",
    };

    setVariantInputs((prev) => [...prev, newRow]);
  };

  // ✅ POST / PUT Estimation
  const handleDetailsSubmit = async (e) => {
    e.preventDefault();

   if (variantInputs.length === 0) {
  toast.error("Please add at least one variant!");
  return;
}

// ✅ Validate quantity for all variants
for (const [index, item] of variantInputs.entries()) {
  const qty = parseFloat(item.qty);
  if (isNaN(qty) || qty <= 0) {
    toast.warning(`Please enter a valid quantity for row ${index + 1}`);
    return;
  }
}

 setLoading(true); // start loading
    const payload = {
      business_id,
      warehouse_id,
      // estimation_number: isEditing
      //   ? undefined
      //   : generateEstimationNumber(),
      estimation_date: new Date().toISOString().slice(0, 10),
    created_by: userId || "",
      remarks: "",
      status: 0,
      details: variantInputs,
    };

    try {
      if (isEditing && editId) {
        await axios.put(
          `${var_api}sa_veemart_estimation/update/${editId}`,
          payload
        );
        toast.success("Estimation updated successfully!");
      } else {
        await axios.post(
          `${var_api}sa_veemart_estimation/post`,
          payload
        );
        toast.success("Estimation created successfully!");
      }

      setShowDetailsModal(false);
      fetchEstimationData();
    } catch (err) {
      toast.error("Error saving estimation");
    }finally {
    setLoading(false); // stop loading
  }
  };
const handleResetForm = () => {
  setVariantInputs([]);
  setFormDataDetails({ product_id: "", variant_id: "" });
  setIsEditing(false);
  setEditId(null);
  toast.info("Form has been reset");
};

  useEffect(() => {
    fetchEstimationData();
  }, []);

 const combinedOptions = productData.flatMap((product) =>
  variantData
    .filter((variant) => variant.product_id === product.id)
    .map((variant) => ({
      label: `${product.product_name} (${product.veemart_product_code || "N/A"}) - ${variant.variant_name}`,
      value: { product_id: product.id, variant_id: variant.id },
    }))
);


  const getStatusBadge = (status) => {
    switch (Number(status)) {
      case 0:
        return <span className="badge bg-secondary">Draft</span>;
      case 1:
        return <span className="badge bg-info">Quoted</span>;
      case 2:
        return <span className="badge bg-success">Converted</span>;
      default:
        return <span className="badge bg-light text-dark">Unknown</span>;
    }
  };

const filteredEstimationData = estimationData.filter((item) => {
  const estimationNum = String(item.estimation_number || "").toLowerCase();
  const estimationDate = item.estimation_date
    ? new Date(item.estimation_date)
        .toLocaleDateString("en-GB")
        .replaceAll("/", "-")
        .toLowerCase()
    : "";
  const query = searchQuery.toLowerCase();

  return estimationNum.includes(query) || estimationDate.includes(query);
});



  return (
    <>
      <Card>
        <Card.Body>
            {pageLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
          <div className="d-flex justify-content-end mb-3 gap-2">
              <Button
                    variant="outline-success"
                    onClick={() => navigate("/quotation")}
                    title="quotation"
                  >
                    <i className="fas fa-external-link-alt"></i>
                  </Button>
            <input
              type="text"
              className="form-control w-auto"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <Button variant="secondary" onClick={handleAddClick}>
              Add
            </Button>
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Estimation Number</th>
                  <th>Estimation Date</th>
                  <th>Created By</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredEstimationData.length === 0 ? (
                  <tr>
                    <td colSpan="6" className="text-center text-muted">
                      No records found
                    </td>
                  </tr>
                ) : (
                  filteredEstimationData.map((item, idx) => (
                    <tr key={item.id}>
                      <td>{idx + 1}</td>
                      <td>{item.estimation_number}</td>
<td>
  {item.estimation_date
    ? new Date(item.estimation_date)
        .toLocaleDateString("en-GB")
        .replaceAll("/", "-")
    : "-"}
</td>
                          <td>{userName || "-"}</td>
<td>
  {item.status === 0 ? (
    <button
      className="badge bg-secondary border-0"
      style={{ cursor: "pointer" }}
      onClick={() => {
        setSelectedEstimationId(item.id);
        setSelectedStatus(null);
        setShowStatusModal(true);
      }}
    >
      Draft
    </button>
  ) : (
    getStatusBadge(item.status)
  )}
</td>
                      <td className="d-flex gap-2">
                   <button
  className="btn shadow btn-xs sharp"
  style={{ backgroundColor: "#1414e1ff", color: "white" }}
  title="View Estimation"
  onClick={() => {
    localStorage.setItem("estimation_id", item.id);
    localStorage.setItem("estimation_number", item.estimation_number);
    localStorage.setItem("estimation_date", item.estimation_date);
    localStorage.setItem("created_by", item.created_by);
    localStorage.setItem("status", item.status);
    navigate(`/estimation-details?estimation_id=${encodeURIComponent(item.id)}`);
  }}
>
  <i className="fas fa-calculator"></i>
</button>


                        {/* <Button
                          size="sm"
                          variant="outline-primary"
                          title="Edit"
                          onClick={() => handleEditClick(item.id)}
                        >
                          <i className="fas fa-edit"></i>
                        </Button> */}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
           </>
          )}
        </Card.Body>
      </Card>

      {/* ✅ Modal */}
      <Modal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? "Edit Estimation" : "Add Estimation"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleDetailsSubmit}>
            <Row className="align-items-end">
              <Col md={5}>
                <Form.Group>
                  <Form.Label>Product + Variant</Form.Label>
                  <Select
                    options={combinedOptions}
                    onChange={(selected) =>
                      setFormDataDetails({
                        product_id: selected.value.product_id,
                        variant_id: selected.value.variant_id,
                      })
                    }
                    placeholder="Select Product & Variant"
                  />
                </Form.Group>
              </Col>
              <Col md={2}>
                <Button
                  type="button"
                  variant="success"
                  onClick={handleAddVariant}
                >
                  <i className="fas fa-plus"></i> Add
                </Button>
              </Col>
            </Row>

            {variantInputs.length > 0 && (
              <>
                <div className="table-responsive mt-3">
                  <table className="table table-bordered">
                    <thead className="table-light">
                      <tr>
                        <th>#</th>
                        <th>Product</th>
                        <th>Variant</th>
                        <th>UOM</th>
                        <th>Gross/Net</th>
                        <th>Qty</th>
                        <th>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {variantInputs.map((v, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{v.product_name}</td>
                          <td>{v.variant_name}</td>
                          <td>{v.uom}</td>
                          <td>
                            {v.gross_weight}/{v.net_weight}
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              min="0"
                              value={v.qty}
                              onChange={(e) =>
                                setVariantInputs((prev) => {
                                  const updated = [...prev];
                                  updated[idx].qty = e.target.value;
                                  return updated;
                                })
                              }
                            />
                          </td>
{/* <td className="text-center">
  <Form.Control
    type="number"
    min="0"
    value={v.qty}
    style={{
      width: "60px",     
      padding: "2px 6px", 
      textAlign: "center",
    }}
    onChange={(e) =>
      setVariantInputs((prev) => {
        const updated = [...prev];
        updated[idx].qty = e.target.value;
        return updated;
      })
    }
  />
</td> */}

                          <td>
                            <Form.Control
                              type="text"
                              value={v.remarks}
                              onChange={(e) =>
                                setVariantInputs((prev) => {
                                  const updated = [...prev];
                                  updated[idx].remarks =
                                    e.target.value;
                                  return updated;
                                })
                              }
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

               <div className="d-flex justify-content-end gap-2 mt-3">
  <Button type="submit" variant="secondary" disabled={loading}>
    {loading ? (
      <>
        <span
          className="spinner-border spinner-border-sm me-2"
          role="status"
          aria-hidden="true"
        ></span>
        {isEditing ? "Updating..." : "Submitting..."}
      </>
    ) : (
      isEditing ? "Update" : "Submit"
    )}
  </Button>

  <Button variant="warning" type="button" onClick={handleResetForm} disabled={loading}>
    <i className="fas fa-undo"></i> Reset
  </Button>

  <Button variant="danger" onClick={() => setShowDetailsModal(false)} disabled={loading}>
    Cancel
  </Button>
</div>

              </>
            )}
          </Form>
        </Modal.Body>
      </Modal>
{/* ✅ Status Update Modal */}
<Modal
  show={showStatusModal}
  onHide={() => setShowStatusModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Update Estimation Status</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <div className="mb-3">
        <Form.Check
          type="radio"
          name="status"
          id="quoted"
          label="Quoted"
          value={1}
          checked={selectedStatus === 1}
          onChange={() => setSelectedStatus(1)}
        />
        <Form.Check
          type="radio"
          name="status"
          id="converted"
          label="Converted"
          value={2}
          checked={selectedStatus === 2}
          onChange={() => setSelectedStatus(2)}
        />
      </div>
    </Form>
  </Modal.Body>
  <Modal.Footer>
   
    <Button
      variant="warning"
      disabled={!selectedStatus || statusUpdating}
      onClick={async () => {
        if (!selectedStatus) {
          toast.warning("Please select a status!");
          return;
        }
        try {
          setStatusUpdating(true);
          await axios.put(`${var_api}sa_veemart_estimation/update-status`, {
            id: selectedEstimationId,
            status: selectedStatus,
          });
          toast.success("Status updated successfully!");
          setShowStatusModal(false);
          fetchEstimationData();
        } catch (err) {
          toast.error("Failed to update status");
        } finally {
          setStatusUpdating(false);
        }
      }}
    >
      {statusUpdating ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
          ></span>
          Updating...
        </>
      ) : (
        "Update"
      )}
    </Button>
     <Button
      variant="danger"
      onClick={() => setShowStatusModal(false)}
      disabled={statusUpdating}
    >
      Cancel
    </Button>
  </Modal.Footer>
</Modal>

      <ToastContainer />
    </>
  );
};

export default EstimationMaster;
